import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { List, ListItemIcon, ListItemText, ListItemButton } from '@mui/material'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import Collapse from '@mui/material/Collapse'

const ListSidebar = ({
  open,
  setOpen
}: {
  open: boolean
  setOpen: Function
}) => {
  const [openItem, setOpenItem] = useState<Record<string, boolean | undefined>>(
    {}
  )

  const navigate = useNavigate()

  const handleOpen = (key: string) => {
    !open && setOpen()
    openItem[key] = open ? !openItem[key] : true
    setOpenItem({ ...openItem })
  }

  const menuItems = [
    {
      text: 'Reporter',
      icon: <InboxIcon />,
      path: '#',
      options: [
        {
          text: 'Nueva',
          path: '/template/create'
        },
        {
          text: 'Lista',
          path: '/template'
        }
      ]
    },

    {
      text: 'Cupones',
      icon: <InboxIcon />,
      path: '#',
      options: [
        {
          text: 'Crear Cupones',
          path: '/coupon/create'
        }
      ]
    }
  ]

  return (
    <List component="nav">
      {menuItems.map((item) => (
        <div key={item.text}>
          <ListItemButton onClick={() => handleOpen(item.text)}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
          {typeof item.options !== 'undefined' && open && (
            <Collapse in={openItem[item.text]} timeout="auto" unmountOnExit>
              {item.options.map((e) => (
                <List key={e.text} component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => navigate(e.path)}>
                    <ListItemText primary={e.text} />
                  </ListItemButton>
                </List>
              ))}
            </Collapse>
          )}
        </div>
      ))}
    </List>
  )
}

export default ListSidebar
